import React from 'react';
import { Outlet } from 'react-router-dom';
import UserDesktopNav from './UserDesktopNav';
import BottomNav from './BottomNav';

/**
 * Oyuncu korumalı rotaları: masaüstünde üst nav, mobilde alt nav.
 * Alt güvenli alan (fixed BottomNav) için pb-20 — yalnızca burada.
 */
export default function PlayerAppShell() {
  return (
    <div className="min-h-screen bg-background flex flex-col pb-20 md:pb-0">
      <UserDesktopNav />
      <main className="flex-1 min-w-0 w-full">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
